<!-- `p-drawer` direto: não há wrapper Vault de painel lateral (ver o README da feature).
     baseZIndex 10300 (faixa das modais, src/styles/Z-INDEX.md) e appendTo body: sem isso a máscara do fundo
     ficava por cima do painel e o campo de comentário não recebia clique. -->

<p-drawer
  [visible]="!!card()"
  (visibleChange)="onVisibleChange($event)"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [baseZIndex]="10300"
  appendTo="body"
  [style]="{ width: '420px', maxWidth: '100vw' }"
  [header]="card()?.bankName || 'Comentários do banco'">
  @if (card(); as current) {
    <div class="journey-comments">
      <section class="journey-comments__summary">
        <div class="journey-comments__bank">
          @if (current.bankCompensationCode) {
            <app-bank-logo [code]="current.bankCompensationCode" [maxWidth]="20" />
          }
          <strong>{{ current.bankName || 'Banco não informado' }}</strong>
        </div>
        <span>{{ current.companyName }} · #{{ current.partnerDealSequentialId }}</span>
        <span class="journey-comments__stage">
          {{ stageLabel(current.stage) }} desde {{ current.stageSince | vaultDate }}
        </span>
      </section>

      <section class="journey-comments__list" aria-label="Comentários">
        @if (loading()) {
          <div class="journey-comments__state">
            <app-cog-loading-spinner [size]="48" />
            <span>Carregando os comentários...</span>
          </div>
        } @else if (error()) {
          <div class="journey-comments__state journey-comments__state--error" role="alert">
            <span>{{ error() }}</span>
            <app-button
              [label]="'Tentar de novo'"
              [theme]="'outline-grey'"
              [type]="'button'"
              (sendButtonClick)="load()" />
          </div>
        } @else if (!comments().length) {
          <p class="journey-comments__state">Ainda não há comentários neste banco.</p>
        } @else {
          @for (comment of comments(); track comment.id) {
            <article class="journey-comment">
              <header class="journey-comment__head">
                <strong>{{ comment.authorName }}</strong>
                <span>{{ comment.createdAt | vaultDateTime }}</span>
              </header>
              <p class="journey-comment__text">{{ comment.text }}</p>
            </article>
          }
        }
      </section>

      @if (canWrite(current)) {
        <section class="journey-comments__composer">
          <app-input
            [type]="'textarea'"
            [label]="'Novo comentário'"
            [placeholder]="'Escreva sobre este banco (aparece também no Pipeline de Crédito)'"
            [textCenter]="false"
            [maxLength]="maxLength"
            [disabled]="sending()"
            [ngModel]="text()"
            (ngModelChange)="text.set($event ?? '')" />
          <app-button
            [label]="'Comentar'"
            [icon]="'pi pi-send'"
            [type]="'button'"
            [isLoading]="sending()"
            [loadingText]="'Gravando...'"
            [disabled]="!canSend()"
            (sendButtonClick)="send()" />
        </section>
      } @else {
        <!-- Card 3848: o parceiro só acompanha; quem comenta com o banco é o time da Legatus. -->
        <p class="journey-comments__closed">
          Os comentários com o banco são feitos pelo time da Legatus. Você acompanha a conversa por aqui.
        </p>
      }
    </div>
  }
</p-drawer>
